<template lang="pug">
md-table-card.card
  form(novalidate='', @submit.stop.prevent='search')
    .filters
      md-layout.search(md-align='end')
        md-layout.searchContainer(md-flex='33', md-align='end')
          md-layout
            md-input-container
              label Search
              md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
          md-layout(md-flex='15', v-if='searchText != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='10')
            md-button.md-icon-button.btn(type='submit', :disabled='loading')
              md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(v-if='loading', :loading='loading', :size='45')
  div(v-if="hasLicensesToDisplay")
    div.titleLine.styleRow
      p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements Status
      p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
      p.rowElements
    div.styleRow.colorHover(v-for='license in licenses', :key='license._id')
      div.rowElements {{license.name}}
      div.rowElements(v-if="license.status === 'public'") live
      div.rowElements(v-else) {{ license.status }}
      div.rowElements {{ license.lastUpdated | moment('from') }}
      div.rowElements
        md-button#editBtn.md-icon-button.md-raised.btn(@click='editLicense(license._id)')
          md-icon.icon(md-iconset="fa fa-pencil-alt")

  md-table-pagination(
    v-show='hasLicensesToDisplay',
    :md-size='currentPagination.size',
    :md-total='totalLicenses',
    :md-page='currentPagination.page',
    md-label='Licenses',
    md-separator='of',
    :md-page-options='[10, 25, 50, 100]',
    @pagination='onPageChanged'
  )

  div#no-results(v-if='hasNoResults')
      md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
      | No items to show
</template>

<script>
import licenseService from '../../services/licenseService';
import stitchLoader from '../../shared-components/Loader';

export default {
  components: {
    stitchLoader
  },
  data() {
    return {
      licenses: [],
      totalLicenses: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: ''
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationLicences") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }
      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalLicenses != null && params.offset >= this.totalLicenses) {
        params.offset = 0
      }

      return params;
    },
    hasLicensesToDisplay() {
      return !this.loading && this.licenses.length > 0;
    },
    hasNoResults() {
      return !this.loading && this.licenses.length === 0;
    }
  },
  methods: {
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageLicences", paginationParams.page);
      this.$session.set("limitPaginationLicences", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },
    search() {
      this.loading = true;
      licenseService.getList(this.searchParams)
        .then((response) => {
          this.licenses = response.data.licenses;
          this.totalLicenses = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of licenses', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    editLicense(licenseId) {
      this.$router.push({
        name: 'EditLicense',
        params: {
          id: licenseId
        }
      });
    },
    cleanSearchText() {
      this.searchText = '';
      this.search()
    },
  },
  mounted() {
    if (this.$session.get("iWasInPageLicences") === undefined) {
      this.$session.set("iWasInPageLicences", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPageLicences');
    if (this.$session.get("limitPaginationLicences") !== undefined) {
      this.currentPagination.size = this.$session.get("limitPaginationLicences");
    }
    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageDistributions", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.search {
  margin-right: 10px;

  @media (max-width: 1200px) {
    margin-right: 20px;
  }
}

.searchContainer {
  flex: none;
}

.filters {
  padding: 2px 20px;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  margin: auto;
  padding: 20px;

  .md-icon {
    margin-right: 5px;
  }
}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #4ea9dd;
}</style>



// WEBPACK FOOTER //
// src/shared-components/license/LicenseTable.vue